import { Box, Heading, HStack, IconButton, Stack } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'

import { useListTicketsQuery } from '../../api'
import { manualWatchListColumns } from './Columns'
import { ConfirmModal } from './ConfirmModal'
import { ResisterModal } from './RegisterModal'

import { AddIcon } from '@/assets/icon'
import { FetchingIndicator, DataTable } from '@/components/Elements'
import { getUserId } from '@/features/auth'
import { useDashboardDispatch } from '@/features/dashboard'

export const ManualWatchList = () => {
    const [query, setQuery] = useState(() => ({
        page: 1,
        limit: 10,
        sort: 'distributedAt',
        direction: 'desc',
        userId: getUserId(),
        status: 'uncompleted',
        type: 'manual',
    }))
    const [initialState] = useState(() => ({
        sortBy: [{ id: query.sort, desc: query.direction === 'desc' }],
        pageSize: query.limit,
    }))
    const { data, isFetching } = useListTicketsQuery(query)

    const dispatch = useDashboardDispatch()
    return (
        <FetchingIndicator as={Stack} isFetching={isFetching}>
            <HStack>
                <Heading>追加候補者</Heading>
                <Box>
                    <IconButton
                        variant="gradient"
                        size="xs"
                        aria-label="refresh"
                        icon={<AddIcon boxSize="1rem" />}
                        onClick={() => {
                            dispatch({ type: 'RESISTER', payload: true })
                        }}
                    />
                </Box>
            </HStack>
            {/* 一覧 */}
            {data && (
                <Table
                    initialState={initialState}
                    items={data.items}
                    pageCount={data.paging.pageCount}
                    setQuery={setQuery}
                />
            )}
            {/* 求職者変更確認 */}
            <ConfirmModal />
            {/* 候補者追加モーダル */}
            <ResisterModal />
        </FetchingIndicator>
    )
}

const Table = ({ setQuery, pageCount, items, initialState }) => {
    const state = DataTable.useServerSide({
        data: items,
        columns: manualWatchListColumns,
        pageCount,
        initialState,
    })
    const {
        state: { pageIndex, sortBy },
    } = state

    // useMemoでクエリパラメータを計算
    const queryParams = useMemo(() => {
        const { id, desc } = sortBy[0]
        return {
            page: pageIndex + 1,
            sort: id,
            direction: desc ? 'desc' : 'asc',
        }
    }, [pageIndex, sortBy])

    // 計算されたパラメータが変更された時のみsetQueryを実行
    useEffect(() => {
        setQuery((prev) => ({
            ...prev,
            ...queryParams,
        }))
    }, [setQuery, queryParams])
    return (
        <DataTable.Provider {...state}>
            <DataTable.Table
                sx={{
                    counterReset: 'row-number',
                }}
            >
                <DataTable.Head />
                <DataTable.Body />
            </DataTable.Table>
            <DataTable.Pagination />
        </DataTable.Provider>
    )
}
Table.propTypes = {
    initialState: PropTypes.any.isRequired,
    pageCount: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    setQuery: PropTypes.func.isRequired,
}
